import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateUnitsSettingsRequest,
  UpdateField,
  FetchUnitsSettingsRequest,
} from './units-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getUnitsSettingsState } from './units-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'
import { FetchAreaRoundingRequest } from '@shared/shared.actions'
import { getAreaRoundingState } from '@shared/shared.select'

@Component({
  selector: 'app-units-settings',
  templateUrl: './units-settings.component.html',
  styleUrls: ['./units-settings.component.css'],
})
export class UnitsSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean
  public areaRoundingOptions = []
  public areaRoundingState$: Subscription

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.areaRoundingState$ = this.store
      .pipe(select(getAreaRoundingState))
      .subscribe((state) => {
        this.areaRoundingOptions = state
      })

    this.state$ = this.store
      .pipe(select(getUnitsSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.store.dispatch(new FetchUnitsSettingsRequest())
    this.store.dispatch<any>(new FetchAreaRoundingRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
    this.areaRoundingState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  public checkboxChange(e: any, name?: string): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, e.target.checked, 'data'),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      SETTINGS_UNITS_AREA_NAME: 'required',
      SETTINGS_UNITS_AREA_SYMBOL: 'required',
      SETTINGS_UNITS_CURRENCY_NAME: 'required',
      SETTINGS_UNITS_CURRENCY_SYMBOL: 'required',
      SETTINGS_UNITS_AREA_TO_METERS: 'required|numeric',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      SETTINGS_UNITS_AREA_NAME: 'area unit name',
      SETTINGS_UNITS_AREA_SYMBOL: 'area unit symbol',
      SETTINGS_UNITS_CURRENCY_NAME: 'currency name',
      SETTINGS_UNITS_CURRENCY_SYMBOL: 'currency symbol',
      SETTINGS_UNITS_AREA_TO_METERS: 'area to meters',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateUnitsSettingsRequest({
          ...payload,
          SETTINGS_UNITS_AREA_TO_METERS: parseFloat(
            payload.SETTINGS_UNITS_AREA_TO_METERS,
          ),
        }),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
